import React, { useCallback, useEffect, useState } from "react";
import { Card, Col, Row, Select, Radio } from "antd";
import SCOOTER3 from "assets/images/red.svg";
import { useDispatch, useSelector } from "react-redux";
import { formatDateAndTime } from "components/Common/Utils";
import { DEMO_EMAIL, ORG_TYPES } from "components/Common/Constants";
import Loading from "components/Common/Loading";
import placeHolderImage from "assets/images/placeHolder.svg";
import { setVehicleFilter } from "reducers/eolSlice";
import { vehicleListApiUrl } from "components/Common/endpoints";
import { getApis } from "components/Common/apis";

const vehicleTypeList = [
  { label: "IMEI", value: "vehImei" },
  { label: "Chassis No", value: "vehChassisNo" },
  { label: "Regn No", value: "vehRegNo" },
];

const vehicleTypeKey = {
  vehImei: "IMEI",
  vehChassisNo: "CHASSIS_NUMBER",
  vehRegNo: "VEHICLE_REGISTRATION_NUMBER",
};

const VehicleDetails = ({
  onChangeImei,
  imei,
  cardHeight,
  extraDetails,
  card = true,
}) => {
  const dispatch = useDispatch();
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const vehicleFilter = useSelector((state) => state.eol.vehicleFilter);
  const vehicleDetails = useSelector((state) => state.eol.vehicleDetails);
  const [vehicleSearch, setVehicleSearch] = useState(null);
  const authToken = localStorage.getItem("authToken");
  const [open, setOpen] = useState(false);

  const handleMouseEnter = () => {
    setOpen(true);
  };

  const handleMouseLeave = () => {
    setOpen(false);
  };

  const getImageUrl = () => {
    if (
      userDetails?.mainOrganisation?.type === ORG_TYPES.ADMINISTRATOR &&
      userDetails?.email === DEMO_EMAIL
    ) {
      return SCOOTER3;
    } else if (vehicleDetails?.images?.length > 0) {
      const item = vehicleDetails?.images?.find(
        (item) => item.tag === "DEFAULT"
      );
      return item ? item.url : null;
    } else {
      return null;
    }
  };

  const onChangeVehicleFilter = (value) => {
    dispatch(setVehicleFilter({ ...vehicleFilter, name: value }));
  };

  const onSearchVehicle = (value) => {
    setVehicleSearch(value || null);
  };

  const getImeiList = useCallback(async () => {
    const response = await getApis(
      vehicleListApiUrl,
      {
        vIdType: vehicleSearch ? vehicleTypeKey[vehicleFilter?.name] : null,
        pattern: vehicleSearch,
        page: 0,
        size: 1000,
      },
      authToken
    );
    dispatch(
      setVehicleFilter({ ...vehicleFilter, list: response?.data || [] })
    );

    // eslint-disable-next-line
  }, [authToken, dispatch, vehicleSearch]);

  useEffect(() => {
    getImeiList();

    // if (!vehicleFilter?.list?.[0]?.vehId || vehicleSearch) {
    //   getImeiList();
    // } else
    if (!imei?.vehImei) {
      onChangeImei(null, vehicleFilter?.list?.[0]);
    }

    // eslint-disable-next-line
  }, [authToken, dispatch, vehicleSearch]);

  return card ? (
    <Card
      bordered={false}
      className="pd025"
      style={{ minHeight: cardHeight ? cardHeight : "auto" }}
    >
      <Row>
        <Col span={24}>
          <Radio.Group
            onChange={(e) => onChangeVehicleFilter(e.target.value)}
            value={vehicleFilter?.name}
            className="mb1 w100"
          >
            <Row gutter={[12, 12]}>
              {vehicleTypeList.map((radio, index) => (
                <Col
                  span={index === 0 ? 6 : index === 1 ? 10 : 8}
                  key={radio.value}
                >
                  <React.Fragment key={index}>
                    <Radio.Button
                      value={radio.value}
                      className="w100 text-center p0 text-overflow"
                    >
                      {radio.label}
                    </Radio.Button>
                  </React.Fragment>
                </Col>
              ))}
            </Row>
          </Radio.Group>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Select
            size="large"
            showSearch
            data-testid="imei-list-dropdown"
            value={imei?.vehId || vehicleFilter?.list?.[0]?.vehId}
            style={{ width: "100%" }}
            onSearch={onSearchVehicle}
            filterOption={false}
            searchValue={vehicleSearch}
            onChange={onChangeImei}
            options={vehicleFilter?.list}
            fieldNames={{
              label: vehicleFilter?.name,
              value: "vehId",
              options: "options",
            }}
          />
        </Col>
      </Row>
      <Row className="mt1">
        <Col span={24}>
          {/* <Spin
            tip="Loading..."
            spinning={!vehicleDetails?.images}
            wrapperClassName="vehicle-img-spin"
          > */}
          {!vehicleDetails?.images && <Loading />}
          {vehicleDetails?.images && (
            <div
              className="vehicle-img"
              onMouseOver={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              {vehicleDetails?.images &&
                (getImageUrl() === null ? (
                  <img alt="Brand" src={placeHolderImage} width="50%" />
                ) : (
                  <img
                    alt="Brand"
                    src={getImageUrl()}
                    width="100%"
                    height="auto"
                  />
                ))}
              {!extraDetails && (
                <Row>
                  <Col span={24}>
                    <Row gutter={8} className="mt05">
                      <Col className="card-bold-text fs1">
                        {vehicleDetails?.vehicleModelName}
                      </Col>
                    </Row>
                    <Row gutter={8} className="mt025" title="Color">
                      <Col className="card-sub-text">
                        {vehicleDetails?.color}
                      </Col>
                    </Row>
                  </Col>
                </Row>
              )}
            </div>
          )}
          {/* </Spin> */}

          {vehicleDetails && extraDetails ? (
            <Row>
              <Col span={24}>
                {vehicleDetails?.color && (
                  <Row gutter={8} className="mt1">
                    <Col className="label" span={12}>
                      Color:
                    </Col>
                    <Col className="card-bold-text" span={12}>
                      {vehicleDetails?.color}
                    </Col>
                  </Row>
                )}
                {vehicleDetails?.weight && (
                  <Row gutter={8} className="mt1">
                    <Col className="label" span={12}>
                      Weight:
                    </Col>
                    <Col className="card-bold-text" span={12}>
                      {vehicleDetails?.weight} kg
                    </Col>
                  </Row>
                )}
                {vehicleDetails?.birthOfVehicle && (
                  <Row gutter={8} className="mt1">
                    <Col className="label" span={12}>
                      Born Date:
                    </Col>
                    <Col className="card-bold-text" span={12}>
                      {vehicleDetails?.birthOfVehicle}
                    </Col>
                  </Row>
                )}
                {vehicleDetails?.vehicleModelName && (
                  <Row gutter={8} className="mt1">
                    <Col className="label" span={12}>
                      Model Name:
                    </Col>
                    <Col className="card-bold-text" span={12}>
                      {vehicleDetails?.vehicleModelName}
                    </Col>
                  </Row>
                )}
                {vehicleDetails?.mfrDate && (
                  <Row gutter={8} className="mt1">
                    <Col className="label" span={12}>
                      Manufacture Date:
                    </Col>
                    <Col className="card-bold-text" span={12}>
                      {vehicleDetails?.mfrDate}
                    </Col>
                  </Row>
                )}
                {vehicleDetails?.driveModeSpeed?.length && (
                  <Row gutter={8} className="mt1">
                    <Col className="label" span={12}>
                      Drive Modes :
                    </Col>
                    <Col className="card-bold-text white-space" span={12}>
                      {vehicleDetails?.driveModeSpeed
                        ?.map((data) => data.mode !== "REVERSE" && data.mode)
                        ?.filter(Boolean)
                        ?.join(",  ")}
                    </Col>
                  </Row>
                )}
              </Col>
            </Row>
          ) : null}

          <div
            className={`${open ? "show" : "hide"} vehicle-drawer`}
            onMouseOver={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            {vehicleDetails && (
              <Row>
                <Col span={24}>
                  <Row gutter={8}>
                    <Col className="card-bold-text fs1">
                      {vehicleDetails?.vehicleModelName}
                    </Col>
                  </Row>
                  <Row gutter={8} className="mt1" title="Color">
                    <Col className="title">{vehicleDetails?.color}</Col>
                  </Row>
                  <Row gutter={8} className="mt05">
                    <Col className="title" title="Born Date">
                      {formatDateAndTime(vehicleDetails?.birthOfVehicle)}
                    </Col>
                  </Row>
                  <Row gutter={8} className="mt05">
                    <Col className="title" title="Manufacture Date">
                      {formatDateAndTime(vehicleDetails?.mfrDate)}
                    </Col>
                  </Row>
                  {vehicleDetails?.weight && (
                    <Row gutter={8} className="mt05">
                      <Col className="title" title="Weight">
                        {vehicleDetails?.weight} kg
                      </Col>
                    </Row>
                  )}
                </Col>
              </Row>
            )}
          </div>
        </Col>
      </Row>
    </Card>
  ) : (
    <Row
      gutter={[0, 12]}
      align={"middle"}
      className="align-center vehicle-filter-box"
    >
      <Col flex="126px">
        {/* <Radio.Group
          onChange={onChangeVehicleFilter}
          value={vehicleFilter?.name}
          className="align-center"
          optionType="button"
          size="large"
          buttonStyle="solid"
        >
          {vehicleTypeList.map((radio, index) => (
            <React.Fragment key={index}>
              <Radio.Button
                value={radio.value}
                className="w100 text-center p0 text-overflow"
              >
                {radio.label}
              </Radio.Button>
            </React.Fragment>
          ))}
        </Radio.Group> */}
        <Select
          size="large"
          showSearch
          variant="borderless"
          value={vehicleFilter?.name}
          className="pd05 vehicle-type"
          style={{ width: "100%" }}
          onChange={onChangeVehicleFilter}
          options={vehicleTypeList}
        />
      </Col>
      <Col flex="auto">
        <Select
          size="large"
          showSearch
          variant="borderless"
          data-testid="imei-list-dropdown"
          value={imei?.vehId || vehicleFilter?.list?.[0]?.vehId}
          style={{ width: "100%" }}
          onSearch={onSearchVehicle}
          filterOption={false}
          searchValue={vehicleSearch}
          onChange={onChangeImei}
          options={vehicleFilter?.list}
          fieldNames={{
            label: vehicleFilter?.name,
            value: "vehId",
            options: "options",
          }}
        />
      </Col>
    </Row>
  );
};

export default VehicleDetails;
